import React, { useState, useEffect } from "react";
import { Fab, Fade } from "@mui/material";
import UpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollFab = () => {
  const [showFab, setShowFab] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY === 0) {
        setShowFab(false); // Hide at the very top
      } else {
        setShowFab(true); // Show as long as not at the top
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Fade in={showFab}>
      <Fab
        color="primary"
        aria-label="add"
        sx={{
          position: "fixed",
          right: 16,
          bottom: 50,
          transform: "translateX(-50%)",
        }}
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      >
        <UpIcon />
      </Fab>
    </Fade>
  );
};

export default ScrollFab;
